import {
  findOfficeUtilitiesOnDate,
  resolveLeasedUtilitySubcategory
} from "@aclymatepackages/calcs/helpers";

// Which subcategory a manually entered utility transaction is saved under.
// `offices` are the raw office docs (useCachedDisplayData("offices")), which
// carry no currentUtilities; a lease change saved with an effective date
// lives only in changes[], so the config is resolved as of the
// transaction's own date. The routing rules themselves live in calcs so the
// backend bill upload and this path can't drift apart.
export const deriveOfficeUtilitySubcategory = ({
  offices = [],
  officeId,
  subcategory,
  date
}) => {
  const selectedOffice = offices.find(({ id }) => id === officeId);

  return resolveLeasedUtilitySubcategory(
    subcategory,
    findOfficeUtilitiesOnDate(selectedOffice, date)
  );
};
